// extracted by mini-css-extract-plugin
module.exports = {"Hobbies":"Hobbies_Hobbies__1Zss9","HobbiesHeading":"Hobbies_HobbiesHeading__391Ga","HobbiesContainer":"Hobbies_HobbiesContainer__4TRLc"};